import { ReservationSystem } from "./ReservationSystem";
import { BrokerSystem } from "./BrokerSystem";
import { BookingForm } from "./BookingForm";
import { BookingView } from "./BookingView";

document.addEventListener("DOMContentLoaded", () => {
  const currentPath = window.location.pathname;

  if (currentPath === "/admin/") {
    new ReservationSystem();
  } else if (currentPath.includes("/booking")) {
    // Check if it's a view page (exact /admin/booking/{id} path)
    const isViewPath = /^\/admin\/booking\/\d+$/.test(currentPath);

    if (isViewPath) {
      new BookingView();
    } else {
      new BookingForm();
    }
  } else {
	new BrokerSystem();
    //console.warn("Unknown page:", currentPath);
  }
});
